module.exports = __webpack_public_path__ + "img/invite-customer.7334f50f.png";